import React from "react";
import DrOsterwalder from "../../../Images/DrOsterwalder.jpg";

const Text7 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);
    return(
      <>
        <p className="content-heading" id="top">
          Optimerad lönsamhet   
      </p>

      <div className="content-text mt-4">

        <p className="heading2">           
          Affärsmodellen genererar Lönsamheten                              
        </p>
        <p>
          All lönsamhet springer ur en affärsmodell. Alltså den process som företagets verksamhet sammantaget utgör. 
          Hur företaget är konfigurerat, hur processer flödar och fungerar och hur lönsamheten skapas. 
        </p>
        <p>
          Verksamheter kan ses som fyra övergripande områden
        </p>
        <ol>
          <li>
            <i>Infrastruktur</i> - alltså personal, maskinpark, kompetens, kapacitet … allt som behövs för att 
            <i> åstadkomma</i> ett kunderbjudande 
          </li>
          <li className="mt-2">
            <i>Utbud</i> av erbjudanden - kärnprodukt(er), paketering, kundvärde, konstruktion … allt du behöver 
            för att metodiskt utveckla lönsamheten i företagets utbud 
          </li>
          <li className="mt-2">
            <i>Kund-interface</i> - hur kanaler för exempelvis kundvård/CRM, marknadsföring/sälj, distribution, 
            installation, underhåll, eftersälj och - viktigt - kunduppföljning ser ut och fungerar … så att du bättre 
            kan utveckla lönsamheten hos din kundportfölj 
          </li>
          <li className="mt-2">
            <i>Finanser</i> - Hur kostnadsstrukturen ser ut, består av och varför samt vilka intäktsströmmar som skapar 
            företagets lönsamhet, med volym, trender och mera. 
          </li>
        </ol>
        <p>
          Din affärsmodell är live. <i>Den är</i> företaget. Men du kan bygga en ”papperskopia” för att du och andra bättre 
          ska förstå och kunna utveckla verksamheten. I starkt förenklad form - så här: 
        </p>
       
        <img
          src={DrOsterwalder}
          alt="imag"
          className="img-fluid max-width:100% height:auto mx-auto d-block"
        />
             
        <p className="imagetext">
          I modellen ovan går värdeflödet från vänster till höger - från Interna Resurser till Målkund.
        </p>
        <p>
          Det finns många ställen i en <i>affärsmodell</i> som kan kalibreras för <i>högre lönsamhet</i>. Fundera kring 
          vad boxar och pilar representerar i ditt unika fall och använd modellen för att identifiera dina viktigaste nycklar 
          till och åtgärder för högre lönsamhet. 
        </p>

        <p className="heading2 mt-4">           
          Nycklar till Lönsamhet                              
        </p>
        <p>
          Hur din affär är modellerad avgör var/hur du bäst, snabbast, billigast åstadkommer högre lönsamhet. 
          Du söker de insatser som ger bäst ”pang” för pengarna
        </p>
        <p>
          Du behöver <i>välja ut</i> och <i>prioritera</i> de <i>värdefullaste</i> insatserna för ökad lönsamhet - i 
          ditt unika fall, vid vald tidpunkt - och tills vidare fokusera tillgängliga resurser på dessa. 
        </p>
        <p>
          För att identifiera dina - för dagen - bästa nycklar/insatsområden behöver du veta vad du letar efter. 
          Det finns några huvudspår att undersöka. 
        </p>
        <ol>
          <li> Utvecklade Erbjudanden (funktion, apparans, distribution, finansiering) </li>
          <li className="mt-1">  Förändrad Utbudsmix (bättre kalibrering mot valda kundgrupper) </li>
          <li className="mt-1"> Ökade Intäkter (pris och/eller volym) </li>
          <li className="mt-1"> Högre Effektivitet och Nyttjandegrad </li>
          <li className="mt-1"> Sänkta Kostnader (rörliga och fasta) </li>
          <li className="mt-1"> Höjda Kostnader som kan bidra till högre Lönsamhet </li>
        </ol>
          
        <p className="heading2 mt-4">           
          Ökade Intäkter (pris och/eller volym)                               
        </p>
        <p>
          För att dina kunder ska betala ett <i>högre pris</i> behöver du leverera ett <i>högre kundvärde</i>.
        </p>
        <p>
          Alltså att kunden - helt uppenbart - upplever högre nytta/värde än vad marknaden hittills erbjudit 
          (eget företag inkluderat). Som känslan av att byta upp sig från en Audi A4 till en A6 exempelvis. 
          Den som har råd betalar gärna mer för den känslan. 
        </p>
        <p>
          Hur kan du höja <i>kundens</i> värdesättning av ditt erbjudande? 
        </p>
        <ul>
          <li> Utvecklad kärnprodukt - högre prestanda, enklare hantering, billigare underhåll? </li>
          <li className="mt-1"> Diversifierade erbjudande som matchar utvalda kundgruppers behov/önskemål? </li>
          <li className="mt-1"> Smartare paketering - exempelvis erbjuda fördelaktig finansiering av affären? </li>
          <li className="mt-1"> Försäkringsskydd, garanti, leverans och kanske i samarbete med extern partner? </li>
          <li className="mt-1"> Kundanpassad leverans - som ”på dörrhandtaget-leverans” av varma frukostbullar? </li>
          <li className="mt-1"> Installation, utbildning, service, underhåll, anpassning, uppdatering och fler tjänster? </li>
          <li className="mt-1"> Mjuka Värden som lyhördhet, servicegrad, punktlighet, respekt, kundfokus? </li>
        </ul>

        <div className="ms-4">

          <p className="heading3 mt-4">           
            Sätta Pris                                
          </p>
          <p>
            När du sätter <i>försäljningspris</i> bör du ha koll på vad konkurrenter debiterar och om det finns någon  
            branschnorm - alltså en prisnivå som marknaden redan accepterat. Samt såklart vad konkurrerande erbjudanden 
            innehåller som är bättre eller sämre än ditt erbjudande. 
          </p>
          <p>
            Om du huvudsakligen konkurrerar med pris behöver du hitta effektiva <i>kostnadssänkare</i>, för att kunna sätta ditt 
            pris meningsfullt under vad marknaden förväntar för ditt erbjudande. 
          </p>
          <p>
            Når du ut med sådant budskap är det svårt att se hur du <i>inte</i> får kunder.<i> Varning</i>: En prissänkning kan vara 
            lätt att följa av konkurrenterna och skapa en ny bransch-prisnivå som blir förödande för din lönsamhet. 
          </p>

          <p className="heading3 mt-4">           
            Ökad leveransvolym                                
          </p>
          <p>
            Kan vara svårt att uppnå utan att också sänka priset. Då gäller i första hand att finna en balans där <i>värdet </i> 
            av volymökning blir <i>större</i> än intäkts-bortfall av lägre försäljningspris. 
          </p>
          <p>
            En lösning kan vara att <i>expandera marknaden</i> - exempelvis geografiskt eller demografiskt. Expansionskostnader 
            kan då ses som en förstklassig investering i företagets framtid - en så kallad ”god” kostnad, att förväntas betala sig väl. 
          </p>
          <p>
            En mera cynisk lösning som praktiseras är att avsiktligt <i>korta produktens livslängd</i>. Det kan vara IT-firman som 
            kortar programvarans uppdateringcykel, eller bilföretaget som kortar motorns livslängd för att istället erbjuda högre 
            motorprestanda, eller kortare utgångsdatum på medicinen och så vidare. Avsiktligt eller oavsiktligt fås kunden att kasta 
            och köpa nytt. 
          </p>
          <p>
            <i>Minska varans eller tjänstens volym</i> med bibehållet pris är ett annat sätt att direkt öka lönsamheten. Men det 
            kommer med lägre försäljningsvolym och risk att stöta bort många - både nya och gamla - kunder som synar den bluffen.  
          </p>
          <p>
            Effektivast för att kamouflera detta lönsamhets-tilltag verkar vara ny design/utformning av erbjudandets förpackning. 
            Sådan ”ny förpackning” kan sträcka sig från behållare för diskmedel till sänkt volymrabatt. 
          </p>
        </div>

        <p className="heading2 mt-4">           
          Sänkta Kostnader (rörliga  och fasta)                                 
        </p>
        <p>
          Innan du börjar arbetet med att analysera dina kostnader så tänk på att kostnader inte bara är något ”nödvändigt ont” 
          utan en viktig komponent i byggandet av ditt företag dvs en del i förtagets strategi.   
        </p>
        <p>
          Det gäller speciellt så kallade ”goda” kostnader, alltså kostnader som bidrar till företagets lönsamhet och utveckling. 
          Har du råd är tipset: Ta dem! Prioritera sådana kostnader och sänk de som minskar vinsten. Skilj på närande och tärande 
          kostnader!  
        </p>
        <p>
          För att sänka kostnader behöver du hitta/identifiera de viktigaste skälen till att de uppstår (Key Cost Drivers) och varför 
          de ökar. Det kan exempelvis vara  
        </p>
        <ul>
          <li> Små inköp från leverantörer/ofördelaktiga avtal </li>
          <li className="mt-1"> Låg produktivitet (tillverkning eller sälj) per tidsenhet </li>
          <li className="mt-1"> Hög kassation/spill </li>
          <li className="mt-1"> Långa ställtider och avbrott i produktionen </li>
          <li className="mt-1"> Små beställningar från kund med stora förberedelser och kringkostnader </li>
          <li className="mt-1"> Låg beläggningsgrad dvs för få produktionstimmar under året </li>
          <li className="mt-1"> Korta produktionsserier </li>
          <li className="mt-1"> Dåliga/felaktiga verktyg </li>
          <li className="mt-1"> Gamla slitna maskiner/lokaler </li>
          <li className="mt-1"> Kvalitetsproblem </li>
          <li className="mt-1"> För stora och för dyra lokaler för behoven </li>
          <li className="mt-1"> Hög kapitalbindning i lager och förråd (kräver utrymme & finansieringskostnader) </li>
          <li className="mt-1"> 
            Ofördelaktig balans mellan andelen producerande respektive indirekt personal (ledning, administration etc) - 
            Jämför med "Pareto-analys" under menyval: "LönsamhetsModeller"
          </li>
        </ul>

        <p>
          Gå igenom och analysera: 
        </p>
        <ul>
          <li> Vilka problem skapas av exempelvis gamla lokaler/nedslitna maskiner? </li>
          <li className="mt-2"> 
            Hur kan ändrad kostandsstruktur ge samma eller bättre resultat till lägre kostnad, (exempelvis lägga ut vissa 
            tillverkningmoment på en extern leverantör)? 
          </li>
          <li className="mt-2"> Finns engångskostnader (ej återkommande) och kan de sänkas med outsourcing?  </li>
          <li className="mt-2">
            Vilka andra kostnader skulle ge bättre resultat om de köps in externt, som exempelvis tillverkning av speciella verktyg? 
          </li>
          <li className="mt-2">
            Kan kostnader reduceras helt eller delvis genom investeringar med <i>kort återbetalningstid</i>, som att köpa en 
            plockrobot som ersätter manuella plockare?  
          </li>
        </ul>
        <p>
          Vid analys och beslut kring kostnader - sök balansera det <i>kortsiktiga</i> behovet med det <i>långsiktiga</i>. 
          Hur stor är skillnaden mellan dagens kostnadsnivå och den som behövs för att nå dina mål om tre till fem år? Kan du 
          exempelvis höja marknadsföringsbudgeten nu, för att nå den volymökning som krävs för att täcka framtida högre 
          kostnadsstruktur? 
        </p>

        <p className="heading2 mt-4">           
          Högre Effektivitet & Nyttjandegrad                                  
        </p>
        <p>
          Ett antal vanliga effektivitetsproblem avhandlas i bulletlistan under föregående avsnitt: ”Sänkta Kostnader”. 
          Här vill vi istället lyfta fram det kanske vanligaste effektivitetsproblemet företag möter - verksamhetens ”flaskhalsar”. 
          En flaskhals kallas också för Trång Sektor och de är ofta är inbyggda i din affärsmodell. 
        </p>

        <div className="ms-4">
          <p className="heading3 mt-4">           
            Trång Sektor = Flaskhals                                   
          </p>
          <p>
            Med ”Trång Sektor” menas alltså en omständighet som begränsar lönsamheten och som hindrar att önskade volymer/priser kan 
            uppnås. Exempelvis 
          </p>
          <ul>
            <li> Fysiskt utrymme - som antal bord i en servering </li>
            <li className="mt-1"> 
              Fysisk tillgänglighet - som 
              <ul>
                <li className="mt-1"> Personal </li>
                <li className="mt-1"> Maskintid </li>
                <li className="mt-1"> Materialförsörjning </li>
              </ul>
            </li>
            <li className="mt-1"> Tillgänglig kompetens/erfarenhet </li>
            <li className="mt-1">
              Rådande Marknadstrend 
              <ul>
                <li className="mt-1"> <i>Stigande</i> marknad medger ofta utrymme för <i>ökande</i> priser </li>
                <li className="mt-1"> 
                  <i>Fallande</i> marknad kräver ofta <i>sänkta</i> priser som då blir en Trång Sektor 
                  Jobbar du i en konjunkturkänslig bransch sker växling mellan stigande och fallande marknadstrend återkommande 
                  (cykliskt). Andra branscher - exempelvis matvaror - är mera stabila och oberoende av rådande konjunktur.  
                </li>
              </ul>
            </li>
          </ul>
          <p>
            Följ dina värdekedjor genom affärsmodellen - från inleverans av råmaterial, kompetens och komponenter (Infrastruktur) genom Utbud, och 
            Kundinterface till Finanser och identifiera dina <i>trånga sektorer</i>. Skissa på lösningar och åtgärder. Vad kostar 
            det att eliminera en Trång Sektor och vad ger det i ökat Täckningsbidrag? 
          </p>
        </div>
          
      </div>

    </>
  );
}
export default Text7;